import React from 'react';
import styled from 'styled-components';
import Icon from './Icon';
import { Wrapper, Text, IconWrapper } from '../styles';
import OrderRefunded from './OrderRefunded';
import formatTime from '../../../utils/formatTime.js';
import {
  ORDER_ACCEPTED,
  ORDER_ON_DELIVERY,
  ORDER_REFUNDED,
  ORDER_REJECTED,
  ORDER_SUBMITTED,
} from '../orderStatusTypes';
import {
  PICKUP,
  DELIVERY,
} from '../../../modules/OrderSetting/orderSettingTypes';

const Button = styled.a`
  width: fit-content;
  font-weight: ${(props) => (props.secondary ? '400' : '600')};
  cursor: pointer;
  font-size: 14px;
  background: none;
  border: none;
  text-decoration: none;
  font-family: ${(props) => props.theme.primaryFontFontFamily};
  border-radius: 17.5px;
  padding: 7px 16px;
  color: ${(props) => props.theme.orderStatusTrackTextColor};
  background: ${(props) => props.theme.orderStatusTrackBackgroundColor};

  @media (max-width: 480px) {
    padding: 3px 8px;
  }

  @media (max-width: 1300px) and (min-width: 1100px) {
    padding: 5px 12px;
  }
`;

const StyledText = styled(Text)`
  @media (max-width: 1300px) and (min-width: 1100px) {
    font-size: 14px;
  }
`;

const SecondaryText = styled.p`
  font-size: 14px;
  font-weight: normal;
  color: #737a87;
  margin: 0;

  @media (max-width: 1300px) and (min-width: 1100px) {
    font-size: 12px;
  }
`;

const StyledIcon = styled(Icon)`
  @media (max-width: 1300px) and (min-width: 1100px) {
    font-size: 28px;
  }
`;

const StaticOrderStatusCard = ({ orderStatus }) => {
  const { status, order_type } = orderStatus;
  const prepTimeInMin = orderStatus.min_prep_time
    ? formatTime(orderStatus.min_prep_time)
    : orderStatus.min_prep_time;
  return (
    <Wrapper>
      {status === ORDER_REFUNDED || status === ORDER_REJECTED ? (
        <OrderRefunded orderStatus={orderStatus} />
      ) : (
        <>
          <IconWrapper>
            {order_type === PICKUP ? (
              <StyledIcon className="fa fa-store" />
            ) : order_type === DELIVERY ? (
              <StyledIcon className="fa fa-car-side" />
            ) : null}
          </IconWrapper>
          <StyledText id="OrderSubmitted-OrderPlaced">
            We have received your {order_type} order
          </StyledText>
          {orderStatus.delivery_tracking_url &&
          order_type === DELIVERY &&
          (status === ORDER_SUBMITTED ||
            status === ORDER_ACCEPTED ||
            status === ORDER_ON_DELIVERY) ? (
            <Button
              id="TrackButton"
              href={orderStatus.delivery_tracking_url}
              target="_blank"
              onClick={(e) => e.stopPropagation()}
            >
              Track Your Order
            </Button>
          ) : order_type === DELIVERY && !orderStatus.is_future_order ? (
            <SecondaryText>
              Approximate delivery time is {prepTimeInMin}
            </SecondaryText>
          ) : null}
          {order_type === PICKUP && !orderStatus.is_future_order ? (
            <SecondaryText>
              Approximate preparation time is {prepTimeInMin}
            </SecondaryText>
          ) : null}
        </>
      )}
    </Wrapper>
  );
};

export default StaticOrderStatusCard;
